import { useDispatch } from "react-redux";

import { useMount } from "app/custom-hooks/useMount";
import ListPageHeader from "app/pages/sales-intelligence/common-components/header/ListPageHeader/ListPageHeader";
import {
    PageInnerContainer,
    StyledPageContainer,
} from "app/pages/sales-intelligence/common-components/layout/page-styles";
import ScrollToTopWrapper from "app/pages/sales-intelligence/common-components/ScrollToTopWrapper/ScrollToTopWrapper";
import withSecondaryBarSet from "app/pages/sales-intelligence/hoc/withSecondaryBarSet";
import EnrichmentTabsContainer from "app/pages/sales-intelligence/modules/enrichment/containers/EnrichmentTabsContainer/EnrichmentTabsContainer";
import DataCreditsIndicatorContainer from "app/pages/sales-intelligence/modules/quota/containers/DataCreditsIndicatorContainer/DataCreditsIndicatorContainer";
import {
    fetchExcelQuotaThunk,
    fetchWorkspacesThunk,
} from "app/pages/sales-intelligence/sub-modules/common/store/effects";
import { fetchContactsUserQuotaThunk } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/effects";

import ErrorBoundaryWithLogging from "../../../../common-components/ErrorBoundaryWithLogging/ErrorBoundaryWithLogging";
import EnrichmentErrorState from "../../components/EnrichmentErrorState/EnrichmentErrorState";

import { StyledDCIndicatorWrapper, StyledTabContainer } from "./styles";

const EnrichmentPageContainer = () => {
    const dispatch = useDispatch();

    useMount(() => {
        void dispatch(fetchWorkspacesThunk());
        void dispatch(fetchExcelQuotaThunk());
        void dispatch(fetchContactsUserQuotaThunk());
    });

    return (
        <ScrollToTopWrapper>
            <ErrorBoundaryWithLogging fallback={<EnrichmentErrorState />}>
                <StyledPageContainer>
                    <PageInnerContainer>
                        <ListPageHeader
                            title={{ key: "si.pages.enrichment.title" }}
                            description={{ key: "si.pages.enrichment.description" }}
                        >
                            <StyledDCIndicatorWrapper>
                                <DataCreditsIndicatorContainer />
                            </StyledDCIndicatorWrapper>
                        </ListPageHeader>
                        <StyledTabContainer>
                            <EnrichmentTabsContainer />
                        </StyledTabContainer>
                    </PageInnerContainer>
                </StyledPageContainer>
            </ErrorBoundaryWithLogging>
        </ScrollToTopWrapper>
    );
};

export default withSecondaryBarSet("SalesIntelligenceLists")(EnrichmentPageContainer);
